import { render, staticRenderFns } from "./HomeTab.vue?vue&type=template&id=5b318653&scoped=true&"
import script from "./HomeTab.vue?vue&type=script&lang=js&"
export * from "./HomeTab.vue?vue&type=script&lang=js&"
import style0 from "./HomeTab.vue?vue&type=style&index=0&id=5b318653&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b318653",
  null
  
)

export default component.exports